import { loginWithRedirect } from '@/helpers/Authentication/authClient';
import { RedirectAction } from '@/helpers/Authentication/redirect';
import { LoginTargetAction, ReferringFeature } from '@/helpers/Authentication/types';
import { logError } from '@/helpers/LogHelper';

export interface GoogleCredentialResponse {
  credential: string;
  select_by: string;
}

export enum Connection {
  Google = 'google-oauth2',
}

export async function handleCredentialResponse(response: GoogleCredentialResponse): Promise<void> {
  try {
    const base64Url = response.credential.split('.')[1];
    if (!base64Url) {
      return;
    }
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );

    const decodedToken = JSON.parse(jsonPayload);
    if (decodedToken.email) {
      await handleGoogleOneTapLogin(decodedToken.email);
    }
  } catch (error) {
    logError('Error handling Google credential response:', undefined, error);
  }
}

export async function handleGoogleOneTapLogin(decodedCredential: string): Promise<void> {
  try {
    await loginWithRedirect(
      LoginTargetAction.login,
      RedirectAction.GOOGLE_ONE_TAP,
      undefined,
      ReferringFeature.GOOGLE_ONE_TAP,
      {
        login_hint: decodedCredential,
        connection: Connection.Google,
      },
    );
  } catch (error) {
    logError('Google One Tap login failed:', undefined, error);
  }
}
